import Vue from 'vue'
import Vuex from 'vuex'
import GlobalStore from '@/stores/modules/globalStore'
import DeviceStore from '@/stores/modules/deviceStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    deviceStore: DeviceStore,
    globalStore: GlobalStore,
  }
})
